// START VARIABLES NEW NEW ENROLLMENT
const libphonenumber = require('google-libphonenumber');
const PNF = require('google-libphonenumber').PhoneNumberFormat;
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
const AsYouTypeFormatter = require('google-libphonenumber').AsYouTypeFormatter;
//const $ = selector => document.querySelector(selector);

const COUNTRIES = [
    "AD", "AE", "AR", "AT", "AU", "BB", "BD", "BE", "BF", "BH", "BJ", "BO", "BR", "BS", "BW", "BZ", "CA", "CD",
    "CF", "CG", "CH", "CI", "CL", "CM", "CN", "CO", "CR", "CU", "DE", "DJ", "DK", "DO", "DZ", "EC", "EG", "ER",
    "ES", "FI", "FJ", "FR", "GA", "GB", "GH", "GM", "GN", "GQ", "GT", "GY", "HK", "HN", "HT", "IE", "IL", "IN",
    "IQ", "IT", "JM", "JO", "KE", "KM", "KW", "LB", "LR", "LS", "LU", "LY", "MA", "MG", "ML", "MR", "MT", "MU",
    "MW", "MX", "MY", "NA", "NE", "NG", "NI", "NO", "NZ", "OM", "PA", "PE", "PG", "PH", "PK", "PR", "PS", "PT",
    "PY", "QA", "RU", "RW", "SA", "SB", "SD", "SE", "SG", "SL", "SN", "SO", "SV", "SY", "SZ", "TD", "TG", "TH",
    "TN", "TT", "TZ", "UG", "US", "UY", "VE", "VU", "WS", "YE", "ZA", "ZM", "ZW"
];

var IsBoot = true;
var callbackBag = {};

var phoneExtensions = [];
var phoneExtensionsLoaded = false;
var phoneExtensionsStrings = [];

var shiftKeyPressed = false;
var escPressCount = 0;

var isRedsysPayment = false;
var isStripePayment = false;
var isEbanxsPayment = false;
var isPaywayPayment = false;

// END VARIABLES NEW NEW ENROLLMENT
const COUNTRY_CODE = document.getElementById('countryCode');
const UPFRONT_PAYMENT = 'contado';
const SPLIT_PAYMENT = 'fraccionado';
const REDSYS_METHOD = 'tarjeta/redsys';
const PAYMENTS_GROUPS = ["tarjeta-group", "cuenta-group", "transferencia-group"];
var paymentModeSelected = UPFRONT_PAYMENT;
var paymentValid = false;
var paymentCardType = null;

var T = {};
var numPedido = undefined;
var leadSent = false;

//new vars
const FIRST_STEP = document.getElementById('enrollment-first-step');
const SECOND_STEP = document.getElementById('enrollment-second-step');
const THIRD_STEP = document.getElementById('enrollment-third-step');
const AREA = document.getElementById("faculty");
const START_DATE = document.getElementById("startDate");
const FINISH_DATE = document.getElementById("finishDate");
const COURSE_TYPE = document.getElementById("courseType");
const COURSE_TITLE = document.getElementById("courseTitle");
const COURSE_PRICE = document.getElementById("coursePrice");
const ORIGINAL_COURSE_ID = document.getElementById("originalCourseId");
const SPECIALITIES = document.getElementById("specialities");
const PRICE_INFO = document.getElementById("priceInfo") != null ? document.getElementById("priceInfo") : "";
const DISCOUNTS = document.getElementById("discounts") != null ? document.getElementById("discounts") : "";
const CURRENCY = document.getElementById("currency");
const CURRENT_URL = document.getElementById("currentUrl");
const COURSE_CODE = document.getElementById("courseCode");
const TYPE_CONTENT = document.getElementById("typeContent");
const CURRENCY_CODE = document.getElementById("currencyCode");
const PROMO_CODE = document.getElementById("promoCode");
const GUARANTOR_ID = document.getElementById("guarantorId");
const QUOTA_PRICE_UPDATE = document.getElementById("quotaPricesUpdated");
const SPECIALITY_LIST = document.getElementById("specialityList");
const NAME_INPUT = document.getElementById("enrollment-name");
const LAST_NAME_INPUT = document.getElementById("enrollment-last-name");
const SECOND_LAST_NAME_INPUT = document.getElementById("enrollment-second-last-name");
const EMAIL_INPUT = document.getElementById("enrollment-email");
var PHONE_EXT_INPUT = document.getElementById("tech-phone-countries-button-value");
const PHONE_INPUT = document.getElementById("enrollment-phone");
const ID_INPUT = document.getElementById("enrollment-id");
const GENERAL_CONDITIONS_INPUT = document.getElementById("enrollment-generalConditions")
const INPUT_PLAZOS = document.getElementById("input-plazos");
const PREORDER_DATA = document.getElementById("preOrderData") != null ? document.getElementById("preOrderData") : "";
const PAYMETHOD_CONTAINER = document.getElementById("enrollment-third-step");
const PAYMENT_MODES = document.getElementById("paymentModes") != null ? document.getElementById("paymentModes") : "";
const SPLIT_PREENROLL_PRICE_FORMATTED = document.getElementById("splitPriceFormatted") != null ? document.getElementById("splitPriceFormatted") : "";

const IS_SPLIT_PAYMENT = document.getElementById("splitPayment").value === "true";
const IS_SUBSCRIPTION = document.getElementById("isSubscription").value === "true";
const INVOICE_BY_PAYMENT = document.getElementById("invoiceByPayment").value === "true";


var priceInfo = (PRICE_INFO.length === 0) ? {} : JSON.parse(PRICE_INFO.value);
var discounts = (DISCOUNTS.length === 0) ? {} : JSON.parse(DISCOUNTS.value);
var paymentModes = (PAYMENT_MODES.value === undefined) ? {} : JSON.parse(PAYMENT_MODES.value);

var userDataBody = null;
var preOrderReq = null;

var phoneFormatter = null;
var validPhone = false;

var payMethodSelected = "tarjeta";
var payModeSelected = "contado";
var firstPreOrderCreated = false;

var CRMOrder = false;
var CRMContactId = null;
var CRMProcessId = null;
var CRMIdVendedor = null;

var CRMData = null;

$(function () {

    //Redsys
    T = JSON.parse(document.getElementById('translations').value.replaceAll("##", "'"));

    var location = document.location.href.split("?");
    if (location.length > 1 && location[1].startsWith("_gl=1")) document.location.href = location[0];

    const queryStringData = window.location.search;
    const urlParams = new URLSearchParams(queryStringData);
    const isCrmEnrollment = document.getElementById("crmEnrollment").value;
    if (isCrmEnrollment) {
        CRMOrder = true;
        CRMData = document.getElementById("crmEnrollmentData").value;
        setPricesAndDiscounts(JSON.parse(CRMData));
        sendTinySuccessNotification(JSON.parse(CRMData));
    }

    tech.lazyLoad.initLazyLoad('.lazyBackground');

    // START NEW NEW ENROLLMENT
    COUNTRIES.forEach((country) => {
        phoneExtensions.push({ "country": country, "code": "+" + phoneUtil.getCountryCodeForRegion(country) });
    })
    if (document.getElementById("tech-phone-countries-button-value") !== null) {
        setDefaultPhoneExtension();
    }
    tech.core.loadScripts([
        'https://cdnjs.cloudflare.com/ajax/libs/jquery-validate/1.19.1/jquery.validate.min.js',
        'https://cdnjs.cloudflare.com/ajax/libs/jquery-validation-unobtrusive/3.2.11/jquery.validate.unobtrusive.min.js',
        'https://cdnjs.cloudflare.com/ajax/libs/jquery.mask/1.14.16/jquery.mask.min.js'
    ]);

    let enrollmentTranslations = [
        "einschreibung",
        "enrolment",
        "inscripcion",
        "inscription",
        "iscrizione",
        "matricula",
        "matricola"
    ]

    if (enrollmentTranslations.includes(document.URL.split('/')[document.URL.split('/').length - 1])) {
        NAME_INPUT !== null ? SetPreenrollmentBlurEvent(NAME_INPUT.querySelector('input')) : "";
        LAST_NAME_INPUT !== null ? SetPreenrollmentBlurEvent(LAST_NAME_INPUT.querySelector('input')) : "";
        EMAIL_INPUT !== null ? SetPreenrollmentBlurEvent(EMAIL_INPUT.querySelector('input')) : "";
        PHONE_INPUT !== null ? SetPreenrollmentBlurEvent(PHONE_INPUT.querySelector('input')) : "";
        ID_INPUT !== null ? SetPreenrollmentBlurEvent(ID_INPUT.querySelector('input')) : "";
    }
    // END NEW NEW ENROLLMENT

    addAutoFill();

    phoneFormatter = new AsYouTypeFormatter(tech.core.getSelectedCountryCode());
});

function disableFeesPayment() {
    document.getElementById('plazosButton').classList.add('hidden-element');
    document.getElementById('enrollment-plazos-input-container').classList.add('hidden-element');
}

function setPricesAndDiscounts(data) {
    priceInfo.Price = data.FinalPrice;
    priceInfo.PriceFormat = data.FinalPriceFormatted;
    priceInfo.InitialQuotaPrice = data.EnrollmentPrice;
    priceInfo.InitialQuotaPriceFormat = data.EnrollmentPriceFormatted;
    priceInfo.QuotaPrice = data.FeePrice;
    QUOTA_PRICE_UPDATE.value = data.FeePrice;
    priceInfo.QuotaPriceFormat = data.FeePriceFormatted;
    priceInfo.QuotaNumber = data.Fees;
}

function disablePromoCode() {
    document.getElementById('promo-code-container').classList.add('hidden-element');
}

export function addAutoFill() {
    document.addEventListener("keydown", (event) => {
        if (event.key === "Shift") {
            shiftKeyPressed = true;
        }

        if (event.key === "Q") {
            if (shiftKeyPressed) {
                escPressCount++;
                if (escPressCount === 2) {
                    autoFillForm();
                    escPressCount = 0;
                }
            }
        } else {
            escPressCount = 0;
        }
    });

    document.addEventListener("keyup", (event) => {
        if (event.key === "Shift") {
            shiftKeyPressed = false;
        }
    })
}

export function autoFillForm() {
    document.getElementById("enrollment-name-input").value = "test";
    document.getElementById("enrollment-last-name-input").value = "test";
    document.getElementById("enrollment-second-last-name-input").value = "test";
    document.getElementById("enrollment-email-input").value = "rlgarcia@techtitute.com";
    document.getElementById("enrollment-phone-input").value = "622222222";
    document.getElementById("enrollment-id-input").value = "12312323A";
    document.getElementById("general-condition-box").value = true;
    validPhone = true;
}

//FUNCION DE CARGA DE TRADUCCIONES POR PAIS
export function changeCountryResidence(countryCode, inputType) {
    countryCode = countryCode.toUpperCase();
    $.ajax({
        type: 'POST',
        url: tech.core.getInternationalUrl('/Course/ChangePersonalDataEnrollmentCountry'),
        data: {
            countryCode: countryCode,
        },
        success: function (response) {
            if (response.succed === true) {
                if (inputType === "phone") {
                    updatePhoneLabel(getTranslation(response.data.translations, "ContactData.Phone", "Teléfono"));
                }
                if (inputType === "country") {
                    updateIDLabel(getTranslation(response.data.translations, "ContactData.DocumentName", "Documento Nacional de Identidad"));
                }
            }
        },
        error: function (jQXHR, textStatus, errorThrown) {
            console.log("An error occurred while trying to contact the server: " + jQXHR.status + " " + textStatus + " " + errorThrown);
        },
    })
}

//FUNCION DE ACTUALIZACION DE LABELS

function updatePhoneLabel(labelValue) {
    document.getElementById("enrollment-phone-input").nextElementSibling.innerText = labelValue;
}

function updateIDLabel(labelValue) {
    document.getElementById("enrollment-id-input").nextElementSibling.innerText = labelValue;
    document.getElementById("enrollment-id-label").setAttribute("title", labelValue);
    EnrollmentId()
}

function getTranslation(translations, code, defaultTranslation) {
    return translationExists(translations, code) ? translations[code] : defaultTranslation;
}

function translationExists(translations, code) {
    return !!translations && !!translations[code];
}

//FUNCION DE ENVIO DE NOTIFICACION DE PREENROLLMENT
export function preEnrollmentNotification() {

    if (CRMOrder) return;

    let request = new XMLHttpRequest();

    request.open("POST", tech.core.getInternationalUrl('/course/preEnrollmentNotification'));
    request.setRequestHeader("Content-Type", "application/json");
    request.setRequestHeader("dataType", "html");

    var params = getParamsPreEnrollment();

    request.onreadystatechange = function () {
        if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
            const response = request.response
            parseScript(response);
        }
    }
    request.send(JSON.stringify(params));
}

export function sendTinySuccessNotification(data) {
    let request = new XMLHttpRequest();

    request.open("POST", tech.core.getInternationalUrl('/course/tinySuccessNotification'));
    request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

    request.onreadystatechange = function () {
        if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
            const response = request.response
            parseScript(response);
        }
    }
    request.send("TinyToken=" + encodeURIComponent(data.TinyToken));
}

//FUNCION PARA EXTRACCION DE SCRIPT Y LLAMDA A FUNCION DEL MISMO
function parseScript(strcode) {
    var scripts = new Array();

    while (strcode.indexOf("<script") > -1 || strcode.indexOf("</script") > -1) {
        var s = strcode.indexOf("<script");
        var s_e = strcode.indexOf(">", s);
        var e = strcode.indexOf("</script", s);
        var e_e = strcode.indexOf(">", e);

        scripts.push(strcode.substring(s_e + 1, e));
        strcode = strcode.substring(0, s) + strcode.substring(e_e + 1);
    }

    for (var i = 0; i < scripts.length; i++) {
        try {
            eval(scripts[i]);
        }
        catch (ex) {
            console.log(ex);
        }
    }
}

//FUNCION PARA RECOLECCION DE DATOS PARA EN ENVÍO DE PRE-ENROLLMENT
function getParamsPreEnrollment() {
    //Get prices and discounts 

    var coursePrice = COURSE_PRICE.value;
    var coursePriceParsed = coursePrice;
    var coursePriceSplitParsed = SPLIT_PREENROLL_PRICE_FORMATTED.value

    if (!!priceInfo) {
        coursePriceParsed = priceInfo.PriceFormat.toString();
    }

    if (!!discounts) {
        coursePrice = discounts.totalDiscount.toString();
        coursePriceParsed = discounts.totalDiscountFormat.toString();
    };

    if (coursePriceSplitParsed == null || coursePriceSplitParsed == "") {
        coursePriceSplitParsed = `${priceInfo.InitialQuotaPriceFormat} + ${priceInfo.QuotaNumber} (${priceInfo.QuotaPriceFormat})`;
    }

    const extensionValue = document.getElementById('tech-phone-countries-button-value').innerText;

    return {
        "name": tech.formFunctions.cleanStrings(NAME_INPUT.querySelector('input').value),
        "title": COURSE_TITLE.value,
        "courseType": COURSE_TYPE.value,
        "surname": tech.formFunctions.cleanStrings(LAST_NAME_INPUT.querySelector('input').value + " " + SECOND_LAST_NAME_INPUT.querySelector('input').value),
        "email": EMAIL_INPUT.querySelector('input').value,
        "phoneNumber": extensionValue + " " + tech.formFunctions.cleanStrings(PHONE_INPUT.querySelector('input').value, true),
        "area": AREA.value,
        "specialities": SPECIALITIES.value,
        "coursePrice": coursePrice,
        "coursePriceParsed": paymentModeSelected == UPFRONT_PAYMENT ? coursePriceParsed : coursePriceSplitParsed,
        "currency": CURRENCY.value,
        "currentUrl": CURRENT_URL.value,
        "originalCourseId": ORIGINAL_COURSE_ID.value,
        "courseCode": COURSE_CODE.value,
        "type": TYPE_CONTENT.value,
        "currencyCode": CURRENCY_CODE.value
    };
}

function getParamsTinyCoupon(data) {
    //Get prices and discounts 

    var coursePrice = COURSE_PRICE.value;
    var coursePriceParsed = coursePrice;
    var coursePriceSplitParsed = SPLIT_PREENROLL_PRICE_FORMATTED.value

    if (!!priceInfo) {
        coursePriceParsed = priceInfo.PriceFormat.toString();
    }

    if (!!discounts) {
        coursePrice = discounts.totalDiscount.toString();
        coursePriceParsed = discounts.totalDiscountFormat.toString();
    };

    if (coursePriceSplitParsed == null || coursePriceSplitParsed == "") {
        coursePriceSplitParsed = `${priceInfo.InitialQuotaPriceFormat} + ${priceInfo.QuotaNumber} (${priceInfo.QuotaPriceFormat})`;
    }

    const extensionValue = document.getElementById('tech-phone-countries-button-value').innerText;

    return {
        "tinyToken": data.TinyToken
    };
}

// CODE VALIDACION DE PROMO CODE
export function validatePromoCode() {
    const promoCodeInput = document.getElementById('tech-promo-code-input');
    const promoCodeText = document.getElementById('tech-promo-code-message');
    if (promoCodeInput.value === "TECH2023") {
        disableFeesPayment();
    }

    if (promoCodeInput.value != null && promoCodeInput.value != '') {
        $.ajax({
            type: 'GET',
            url: tech.core.getInternationalUrl('/Course/ValidatePromoCode'),
            data: {
                originalCourseId: ORIGINAL_COURSE_ID.value,
                promoCode: promoCodeInput.value,
                facultyUrl: AREA.value,
            },
            success: function (response) {

                if (response.data) {

                    promoCodeText.classList.remove('tech-error-message');
                    promoCodeText.classList.add('tech-succed-message');

                    if (!IS_SPLIT_PAYMENT) {
                        document.getElementById("total-price-promo").classList.remove('hidden-element')
                        document.getElementById("price-label").classList.add('hidden-element')
                        document.getElementById("promo-price-label").classList.remove('hidden-element')

                    }

                    promoCodeText.innerHTML = T.promoCodeSucced;

                    //UPDATE THE DISCOUNTS HIDDEN WITH THE NEW DATA
                    DISCOUNTS.value = JSON.stringify(response.data);
                    discounts = JSON.parse(DISCOUNTS.value);
                    PROMO_CODE.value = promoCodeInput.value;

                    document.getElementById("totalPriceFormatted").classList.add('payment-type-label-discount');
                    if (document.getElementById("totalPriceFormatted-check") !== null) {
                        document.getElementById("totalPriceFormatted-check").innerHTML = discounts.totalDiscountFormat;
                    }

                    document.getElementById("enrollment-first-price").innerHTML = discounts.initialFeeFormat;
                    document.getElementById("enrollment-fee-price").innerHTML = discounts.recurrentFeeFormat;
                } else {
                    promoCodeText.classList.remove('tech-succed-message');
                    promoCodeText.classList.add('tech-error-message');
                    promoCodeText.innerHTML = T.promoCodeError;
                }
            },
            error: function () {
                promoCodeText.innerHTML = T.promoCodeError;
                promoCodeInput.classList.add('error');
            }
        });
    }
}

//FUNCION PARA REVISAR CONDICIONES Y POSIBILIDAD DE ACTIVAR BOTÓN
function checkPaymentSubmit() {
    var submitButton = $('#pay-button');
    if (submitButton) {
        if (paymentValid) {
            submitButton.removeClass('disabled');
            submitButton.prop('disabled', false);
        } else {
            submitButton.addClass('disabled');
            submitButton.prop('disabled', true);
        }
    }
}

function buildRequestBody() {
    var CTBCode = JSON.parse(CRMData) === null ? "" : JSON.parse(CRMData).CourseTypeBaseCode;
    var customRemarks = "";
    if (CTBCode === "026") customRemarks = "##pack##";
    if (CTBCode === "027") customRemarks = "##paso a pack##"
    let body = {
        Area: AREA.value,
        AffiliateCode: !!tech.core.getCookie(tech.core.AFFILIATE_COOKIE) ? tech.core.getCookie(tech.core.AFFILIATE_COOKIE) : undefined,
        PromotionalCode: !!PROMO_CODE.value ? PROMO_CODE.value : undefined,
        GuarantorId: GUARANTOR_ID.value,
        CourseInfo: buildCourseInfo(),
        PersonalData: buildPersonalData(),
        PaymentInfo: buildPaymentInfo(),
        Remarks: customRemarks,
        ContactData: buildContactlData(),
        AcademicData: undefined,
        WorkingInformation: undefined,
        UserAgent: window.navigator.userAgent,
        TrackingInfo: undefined,
        PoliciesAccepted: true,
        ConditionsAccepted: true,
        PreviousOrderNumber: numPedido,
        Teleoperadora: JSON.parse(CRMData) === null ? "" : JSON.parse(CRMData).VendorId + "",
        ProcessId: JSON.parse(CRMData) === null ? 0 : JSON.parse(CRMData).ProcessId,
        SplitPaymentOnly: IS_SPLIT_PAYMENT,
        IsSubscription: IS_SUBSCRIPTION,
        InvoiceByPayment: INVOICE_BY_PAYMENT
    };
    return body;
}

function buildCourseInfo() {
    var price = null;
    var initialQuotaPrice = null;
    var quotaPrice = null;
    var quotaNumber = null;

    var CTBCode = JSON.parse(CRMData) === null ? "" : JSON.parse(CRMData).CourseTypeBaseCode;
    var customCourseType = "";
    if (CTBCode === "026") customCourseType = "Pack";
    if (CTBCode === "027") customCourseType = "Paso a Pack";
    if (customCourseType === "") customCourseType = COURSE_TYPE.value;

    if (IS_SPLIT_PAYMENT) {
        price = priceInfo.InitialQuotaPrice + (priceInfo.QuotaPrice * 11);
        quotaNumber = IS_SUBSCRIPTION ? 0 : parseInt(INPUT_PLAZOS.value);
        quotaPrice = priceInfo.QuotaPrice;
        initialQuotaPrice = priceInfo.InitialQuotaPrice;
    } else {
        if (paymentModeSelected == UPFRONT_PAYMENT) {
            initialQuotaPrice = 0;
            quotaPrice = 0;
            quotaNumber = 0;

            if (discounts === null) {
                price = priceInfo.Price;
            } else {
                price = discounts.totalDiscount;
            }

        } else {

            quotaPrice = parseFloat(QUOTA_PRICE_UPDATE.value);
            quotaNumber = parseInt(INPUT_PLAZOS.value);
            if (discounts === null) {
                quotaPrice = QUOTA_PRICE_UPDATE.value === "" ? priceInfo.QuotaPrice : parseFloat(QUOTA_PRICE_UPDATE.value);
                initialQuotaPrice = priceInfo.InitialQuotaPrice;
                price = initialQuotaPrice + (quotaNumber * quotaPrice);
            } else {
                quotaPrice = QUOTA_PRICE_UPDATE.value === "" ? discounts.recurrentFee : parseFloat(QUOTA_PRICE_UPDATE.value);
                initialQuotaPrice = discounts.initialFee;
                price = initialQuotaPrice + (quotaNumber * quotaPrice);
            }
        }
    }

    let body = {
        OriginalCourseId: parseInt(ORIGINAL_COURSE_ID.value, 10),
        CourseCode: COURSE_CODE.value,
        Title: COURSE_TITLE.value,
        CourseType: JSON.parse(CRMData) === null ? COURSE_TYPE.value : customCourseType,
        Type: TYPE_CONTENT.value,
        StartDate: START_DATE.value,
        FinishDate: FINISH_DATE.value,
        Price: price,
        InitialQuotaPrice: initialQuotaPrice,
        QuotaPrice: quotaPrice,
        QuotaNumber: quotaNumber,
        Currency: priceInfo.Currency + '(' + priceInfo.CurrencyCode + ')',
        CurrencyCode: CURRENCY_CODE.value,
        Country: COUNTRY_CODE.value,
        Specialities: JSON.parse(SPECIALITY_LIST.value),
        CourseTypeBaseCode: JSON.parse(CRMData) === null ? "" : JSON.parse(CRMData).CourseTypeBaseCode
    };
    return body;
}

function buildPersonalData() {
    let body = {
        Name: tech.formFunctions.cleanStrings(NAME_INPUT.querySelector('input').value),
        Surname: tech.formFunctions.cleanStrings(LAST_NAME_INPUT.querySelector('input').value + " " + SECOND_LAST_NAME_INPUT.querySelector('input').value),
        Email: EMAIL_INPUT.querySelector('input').value,
        PhoneNumber: PHONE_EXT_INPUT.innerText + " " + tech.formFunctions.cleanStrings(PHONE_INPUT.querySelector('input').value, true),
        Gender: "PENDIENTE",
        Nationality: "PENDIENTE",
        BirthDate: new Date().toISOString(),
        Profession: "PENDIENTE"
    };
    return body;
}

function buildPaymentInfo() {
    let body = {
        PaymentMode: (paymentModeSelected == UPFRONT_PAYMENT) ? 1 : 2,
        NTarjeta: (!!document.getElementById('tarjeta-group') && !isCardEmpty())
            ? [document.getElementById('enrollment-card-number-input').value, document.getElementById('enrollment-card-cvv-input').value, document.getElementById('enrollment-card-expiry-input').value].join('-')
            : '',
        NCuenta: ((!!document.getElementById('cuenta-group') || !!document.getElementById('transferencia-group')) && !isAccountEmpty())
            ? [document.getElementById('IbanCountryCode').value, document.getElementById('IbanEntity').value, document.getElementById('IbanOffice').value,
                document.getElementById('IbanControlDigit').value, document.getElementById('IbanAccountNumber').value].join('-')
            : '',
        PaymentType: getPaymentType()
    };
    return body;
}

function isCardEmpty() {
    return (document.getElementById('enrollment-card-number-input').value.length == 0) &&
        (document.getElementById('enrollment-card-cvv-input').value.length == 0) &&
        (document.getElementById('enrollment-card-expiry-input').value.length == 0);
}

function isAccountEmpty() {
    return (document.getElementById('IbanCountryCode').value.length == 0) &&
        (document.getElementById('IbanEntity').value.length == 0) &&
        (document.getElementById('IbanOffice').value.length == 0) &&
        (document.getElementById('IbanControlDigit').value.length == 0);
}

function getPaymentType() {
    const PAYMENT_MODES = document.getElementById("paymentModes").value;
    const PAYMENT_METHOD = (document.getElementById("paymentMethodSelected") === null) ? "tarjeta" : document.getElementById("paymentMethodSelected").value;

    if (!!PAYMENT_MODES) {
        if (PAYMENT_METHOD === "tarjeta") {
            let methods = JSON.parse(PAYMENT_MODES);
            for (let e of methods) {
                if (e.CardListPaymentMethod[0].Plataform === 'redsys') {
                    isRedsysPayment = true;
                    return 'tarjeta/' + e.CardListPaymentMethod[0].Plataform + '/' + paymentModeSelected
                } else if (e.CardListPaymentMethod[0].Plataform === 'stripe') {
                    isStripePayment = true;
                    return 'tarjeta/' + e.CardListPaymentMethod[0].Plataform + '/' + paymentModeSelected
                } else if (e.CardListPaymentMethod[0].Plataform === 'ebanx') {
                    isEbanxsPayment = true;
                    return 'tarjeta/' + e.CardListPaymentMethod[0].Plataform + '/' + paymentModeSelected
                } else if (e.CardListPaymentMethod[0].Plataform === 'payway') {
                    isPaywayPayment = true;
                    return 'tarjeta/' + e.CardListPaymentMethod[0].Plataform + '/' + paymentModeSelected
                } else {
                    return e.CardListPaymentMethod[0].Plataform + '/' + paymentModeSelected;
                }
            }
        } else {
            return PAYMENT_METHOD + '/' + paymentModeSelected;
        }
    } else {
        isRedsysPayment = true;
        return REDSYS_METHOD + '/' + paymentModeSelected;
    }

}

function buildContactlData() {
    let body = {
        Document: ID_INPUT.querySelector('input').value,
        Issued: "PENDIENTE",
        Address: "PENDIENTE",
        Location: "PENDIENTE",
        Cp: "PENDIENTE",
        Town: "PENDIENTE",
        Subdivision: "PENDIENTE",
        State: "PENDIENTE",
        Country: "PENDIENTE"
    };

    return body;
}

//FUNCION CUANDO SE ENVIA EL FORMULARIO COMPLETO


export function submitEnrollmentForm() {


    tech.formFunctions.toggleSpinner('spinner-pay-button', ['button-label'], ['enrollment-third-step']);
    const parsedData = buildRequestBody();

    $.ajax({
        type: 'POST',
        url: tech.core.getInternationalUrl('/Course/SendNewEnrollment'),
        data: JSON.stringify(parsedData),
        contentType: 'application/json',
        dataType: 'html',
        success: function (content, status) {

            tech.formFunctions.scrollToElement(THIRD_STEP);
            tech.formFunctions.toggleSpinner('spinner-pay-button', ['button-label'], ['enrollment-third-step']);
            PAYMETHOD_CONTAINER.innerHTML = "";
            $('#enrollment-third-step').append(content);

            $(document).ready(function () {
                numPedido = document.getElementById('orderNumber').value
            });

            //sendNotificationCRM(parsedData, numPedido)
        },
        error: function (content) {
            tech.formFunctions.toggleSpinner('spinner-pay-button', ['button-label'], ['enrollment-third-step']);
            showPaymentInfoModal(T.errorMatricula);
        }
    });
}

function sendNotificationCRM(data) {
    $.ajax({
        type: 'POST',
        url: 'https://test.crm.intranet.techtitute.com/api/Processes/ExternalSuccessfulSaleProcessCommand',
        data: JSON.stringify(buildCRMData(data)),
        contentType: 'application/json',
        dataType: 'json',
        success: function (content, status) {
            console.log('OK')
        },
        error: function (content) {
            console.log('KO')
        }
    })
}

function buildCRMData(data, numPedido) {
    return body = {
        ContactId: CRMContactId,
        ProcessId: CRMProcessId,
        StudentName: tech.formFunctions.cleanStrings(NAME_INPUT.querySelector('input').value) + " " + tech.formFunctions.cleanStrings(LAST_NAME_INPUT.querySelector('input').value + " " + SECOND_LAST_NAME_INPUT.querySelector('input').value),
        IdCard: data.ContactData.IdCard,
        Email: EMAIL_INPUT.querySelector('input').value,
        Phone: PHONE_EXT_INPUT + " " + tech.formFunctions.cleanStrings(PHONE_INPUT.querySelector('input').value, true),
        Address: "PENDIENTE",
        Country: "PENDIENTE",
        Province: "PENDIENTE",
        PostalCode: "PENDIENTE",
        City: "PENDIENTE",
        OrderNumber: numPedido,
        OrderDate: new Date().toISOString(),
        AcademicTitle: data.CourseInfo.Title,
        InitDate: data.CourseInfo.StartDate,
        PaymentType: data.PaymentInfo.PaymentType,
        CurrencyCountry: data.CourseInfo.CurrencyCode,
        NumberDeadLines: data.CourseInfo.QuotaNumber,
        SalesCountry: data.CourseInfo.Country,
        AmountRegistration: courseInfo,
    }
}


//FUNCION PARA AÑADIR LISTER A LOS INPUTS DE PAYMENT SELECCIONADOS
export function addChangeListener(groupInputs, methodSelected) {
    for (let i = 0; i < groupInputs.length; i++) {
        groupInputs[i].addEventListener('keyup', function () { checkPaymentForSubmit(groupInputs, methodSelected) });
        groupInputs[i].addEventListener('blur', function () { checkPaymentForSubmit(groupInputs, methodSelected) });
    };
}

//FUNCION DE CHECKEO DE VALIDEZ DE LOS INPUTS DE PAGO IBAN-TARJETA
function checkPaymentForSubmit(inputs, method) {
    switch (method) {
        case PAYMENTS_GROUPS[0]:

            var cardInputvalid = false;
            var dateInputvalid = false;
            var cvvInputvalid = false;

            var cardNumber = inputs[0].value;
            var cardExpiry = inputs[1].value;
            var cardCvv = inputs[2].value;

            var cardNumberValidator = /^(\d{4}\s){3}\d{4}$/;
            var cardExpiryValidator = /(?:0[1-9]|1[0-2])\s\/\s[0-9]{2}/;
            var cardCvvValidator = /^\d{3}$/;

            var cardNumberInput = inputs[0];
            var cardExpiryInput = inputs[1];
            var cardCvvInput = inputs[2];

            //REVISION DE TARJETA MANUAL SEGUN SUS PRIMEROS DIGITOS
            if (cardNumber != "") {
                if (cardNumber.startsWith('37')) {
                    paymentCardType = "american-express";
                    cardNumberValidator = /^\d{4}\s\d{6}\s\d{5}$/;
                    cardCvvValidator = /^\d{4}$/;
                    $(cardNumberInput).mask('9999 999999 99999');
                    $(cardCvvInput).mask('9999');

                } else if (cardNumber.startsWith('4')) {

                    paymentCardType = "visa";
                    $(cardNumberInput).mask('9999 9999 9999 9999');
                    $(cardCvvInput).mask('999');

                } else if (['51', '52', '53', '54', '55'].some(code => cardNumber.startsWith(code))) {

                    paymentCardType = "mastercard";
                    $(cardNumberInput).mask('9999 9999 9999 9999');
                    $(cardCvvInput).mask('999');

                } else {
                    paymentCardType = "undefined";
                    $(cardNumberInput).mask('9999 9999 9999 9999');
                    $(cardCvvInput).mask('999');
                }

                if (paymentCardType != null) {
                    cardInputvalid = cardNumberValidator.test(cardNumber);
                    setValidOrInvalidPaymentInput(cardNumberInput, cardInputvalid);
                } else {
                    setValidOrInvalidPaymentInput(cardNumberInput, false);
                    cardInputvalid = false;
                }

            } else {
                cardInputvalid = false;
            }

            //INSERCION DE SLASH PARA LA FECHA DE EXPIRACION
            if (cardExpiry != "") {

                if (cardExpiry.length == 2 && !cardExpiry.includes(" / ")) {
                    inputs[1].value = cardExpiry + " / ";
                } else {
                    if (cardExpiry.length == 4 && cardExpiry.charAt(3) === '/') {
                        inputs[1].value = cardExpiry.replace(" /", '');
                    }
                }

                if (cardExpiry.length == 7) {
                    var today = new Date();
                    var month = ("0" + (today.getMonth() + 1)).slice(-2);
                    var year = today.getFullYear().toString().slice(-2);

                    var cardExpiryParsed = cardExpiry.replace(/\s/g, '');
                    var dateExpiry = cardExpiryParsed.split('/');

                    var expiryMonthValidator = /(?:0[1-9]|1[0-2])/;

                    //REVISION DE FECHAS VALIDAS A PARTIR DE EL MISMO DIA
                    if (expiryMonthValidator.test(dateExpiry[0])) {
                        if (parseInt(dateExpiry[1]) > parseInt(year)) {

                            dateInputvalid = true;

                        } else if (parseInt(dateExpiry[1]) == parseInt(year)) {

                            if (parseInt(dateExpiry[0]) >= parseInt(month)) {
                                dateInputvalid = true;
                            } else {
                                dateInputvalid = false;
                            }

                        } else {
                            dateInputvalid = false;
                        }
                    } else {

                        dateInputvalid = false;
                    }

                    setValidOrInvalidPaymentInput(cardExpiryInput, dateInputvalid);

                } else {
                    dateInputvalid = false;
                    setValidOrInvalidPaymentInput(cardExpiryInput, dateInputvalid);
                }

            } else {
                dateInputvalid = false;
            }

            //REVISION de CVV
            if (cardCvv != "") {
                if (cardCvv.length == 3 || cardCvv.length == 4) {
                    if (cardCvvValidator.test(cardCvv)) {
                        cvvInputvalid = true;
                    }
                } else {
                    cvvInputvalid = false;
                }
                setValidOrInvalidPaymentInput(cardCvvInput, cvvInputvalid);
            } else {
                paymentValid = cvvInputvalid;
            }

            if (cardInputvalid && dateInputvalid && cvvInputvalid) {
                paymentValid = true;
            } else {
                paymentValid = false;
            }

            checkPaymentSubmit();


            break;

        case PAYMENTS_GROUPS[1]:

            paymentValid = true;

            const validators = [
                { inputIban: inputs[0], validator: /^[A-Z]{2}\d{2}$/ },
                { inputIban: inputs[1], validator: /^\d{4}$/ },
                { inputIban: inputs[2], validator: /^\d{4}$/ },
                { inputIban: inputs[3], validator: /^\d{2}$/ },
                { inputIban: inputs[4], validator: /^\d{10}$/ },
            ];

            for (const input of validators) {
                const value = input.inputIban.value;
                const isValid = input.validator.test(value);
                if (value != "") {
                    setValidOrInvalidPaymentInput(input.inputIban, isValid);
                }
                paymentValid = paymentValid && isValid;
            }


            checkPaymentSubmit();
            break;
    }
}

function setValidOrInvalidPaymentInput(input, isValid) {
    input.classList.toggle('input-validation-error', !isValid);
    input.classList.toggle('valid', isValid);
}

export function setAutoFocusPaymentInput(idInput) {
    $("#" + idInput + " input").bind("input", function () {
        var $this = $(this);
        setTimeout(function () {
            let value = $this.val();
            if (value && value.length >= parseInt($this.attr("data-val-maxlength-max")))
                $this.next("input").focus();
        }, 0);
    });
}

function showPaymentInfoModal(errorMessage) {
    $('#payment-info-modal').modal({
        keyboard: false,
        backdrop: 'static'
    });
    $('#message-payment-modal').html('<p>' + errorMessage + '</p>');
    $('#payment-info-modal').modal('show');
}

export function selectPayForm(paymentForm) {
    const CONTADO_BUTTON = document.getElementById("contadoButton");
    const PLAZOS_BUTTON = document.getElementById("plazosButton");
    const TOTAL_PAYMENT = document.getElementById("payment-total");
    const DIVIDED_PAYMENT_INITIAL = document.getElementById("divided-payment-initial");
    const DIVIDED_PAYMENT_CUOTA = document.getElementById("divided-payment-cuota");
    const PAY_FORM_LABEL = document.getElementById("selected-pay-form");

    if (paymentForm === "contado") {
        // UPDATE PRICE CONTADO (default)
        document.getElementById("enrollment-plazos-input-container").classList.contains('d-none') ? "" : document.getElementById("enrollment-plazos-input-container").classList.add("d-none");
        PAY_FORM_LABEL.innerText = T.modoPago + ": " + T.alContado;
        CONTADO_BUTTON.classList.add("tech-selectable-button-selected");
        PLAZOS_BUTTON.classList.remove("tech-selectable-button-selected");
        TOTAL_PAYMENT.classList.contains("hidden-element") ? TOTAL_PAYMENT.classList.remove("hidden-element") : null;
        DIVIDED_PAYMENT_INITIAL.classList.contains("hidden-element") ? null : DIVIDED_PAYMENT_INITIAL.classList.add("hidden-element");
        DIVIDED_PAYMENT_CUOTA.classList.contains("hidden-element") ? null : DIVIDED_PAYMENT_CUOTA.classList.add("hidden-element");
        INPUT_PLAZOS.value = 1;
        INPUT_PLAZOS.readOnly = true;
        paymentModeSelected = UPFRONT_PAYMENT;
        if (discounts === null) {
            TOTAL_PAYMENT.querySelector("#payment-total-amount").innerHTML = priceInfo.PriceFormat;
        } else {
            TOTAL_PAYMENT.querySelector("#payment-total-amount").innerHTML = discounts.totalDiscountFormat;
        }
        showPaymentsMethodButtons();
        tech.formFunctions.scrollToElement(SECOND_STEP);
        if (!firstPreOrderCreated) {
            firstPreOrderCreated = true;
            createPreOrder().catch(err => {
            });
        }
    } else if (paymentForm === "plazos") {

        var paymentModesLenght = JSON.parse(PAYMENT_MODES.value).length;
        if (IS_SUBSCRIPTION) {
            document.getElementById("enrollment-plazos-input-container").classList.add('d-none');
        } else {
            document.getElementById("enrollment-plazos-input-container").classList.contains('d-none') ? document.getElementById("enrollment-plazos-input-container").classList.remove("d-none") : "";
        }
        // UPDATE PRICE Cuota inicial + Cuotas
        PAY_FORM_LABEL.innerText = T.modoPago + ": " + T.aPlazos;
        CONTADO_BUTTON?.classList.remove("tech-selectable-button-selected");
        PLAZOS_BUTTON.classList.add("tech-selectable-button-selected");
        if (!IS_SUBSCRIPTION) {
            TOTAL_PAYMENT.classList.contains("hidden-element") ? null : TOTAL_PAYMENT.classList.add("hidden-element");
            INPUT_PLAZOS.readOnly = false;
        }
        DIVIDED_PAYMENT_INITIAL.classList.contains("hidden-element") ? DIVIDED_PAYMENT_INITIAL.classList.remove("hidden-element") : null;
        DIVIDED_PAYMENT_CUOTA.classList.contains("hidden-element") ? DIVIDED_PAYMENT_CUOTA.classList.remove("hidden-element") : null;
        paymentModeSelected = SPLIT_PAYMENT;
        if (discounts === null) {
            DIVIDED_PAYMENT_INITIAL.querySelector("#payment-divided-price-initial-amount").innerHTML = priceInfo.InitialQuotaPriceFormat;
            DIVIDED_PAYMENT_CUOTA.querySelector("#payment-divided-price-cuota-amount").innerHTML = priceInfo.QuotaPriceFormat;
            if (!IS_SUBSCRIPTION) {
                DIVIDED_PAYMENT_CUOTA.querySelector("#payment-divided-price-cuota .months-amount").innerHTML = priceInfo.QuotaNumber;
            }
            INPUT_PLAZOS.value = priceInfo.QuotaNumber;
        } else {
            DIVIDED_PAYMENT_INITIAL.querySelector("#payment-divided-price-initial-amount").innerHTML = discounts.initialFeeFormat;
            DIVIDED_PAYMENT_CUOTA.querySelector("#payment-divided-price-cuota-amount").innerHTML = discounts.recurrentFeeFormat;
            if (!IS_SUBSCRIPTION) {
                DIVIDED_PAYMENT_CUOTA.querySelector("#payment-divided-price-cuota .months-amount").innerHTML = discounts.feesCount;
            }
            INPUT_PLAZOS.value = discounts.feesCount;
            QUOTA_PRICE_UPDATE.value = discounts.recurrentFee;
        }
        showPaymentsMethodButtons();
        tech.formFunctions.scrollToElement(SECOND_STEP);
    }
}

function showPaymentsMethodButtons() {
    //EN PRINCIPIO SIEMPRE SE MUSTRA EL BOTON DE TARJETA EL DE CUENTA NO

    // Buscar el modo de pago correspondiente
    var paymentModeObj = paymentModes.find(function (mode) {
        return mode.Name === paymentModeSelected;
    });

    // Si no se encontró el modo de pago, devolver false
    if (!paymentModeObj) {
        return false;
    }

    // Buscar si el paymentMethods contiene un método con name 'cuenta'
    var hasCuenta = paymentModeObj.HasAccount;

    let buttonCuenta = document.getElementById('cuentaButton');

    if (hasCuenta) {
        buttonCuenta.classList.remove('hidden-element');
    } else {
        buttonCuenta.classList.add('hidden-element');
    }

}

export function updateFeeCountPrices(element) {

    let maxCuotas = Number.parseInt(element.getAttribute('input-limit'));

    let realValue = (element.value === "" ? maxCuotas : element.value);



    if (Number.parseInt(realValue) >= maxCuotas) {
        element.value = maxCuotas;
    } else if (Number.parseInt(realValue) <= 0) {
        element.value = 1;
    }

    const DIVIDED_PAYMENT_CUOTA = document.getElementById("divided-payment-cuota");
    let standardFeeCount = discounts === null ? priceInfo.QuotaNumber : discounts.feesCount;
    let initialFee = discounts === null ? priceInfo.InitialQuotaPrice : discounts.initialFee;
    let priceFormat = discounts === null ? priceInfo.QuotaPriceFormat : discounts.recurrentFeeFormat;
    let standardQuotaPrice = discounts === null ? priceInfo.QuotaPrice : discounts.recurrentFee;
    let totalAmount = discounts === null ? initialFee + (standardQuotaPrice * standardFeeCount) : discounts.initialFee + (discounts.recurrentFee * discounts.feesCount);

    let feeCounts = element.value;

    if (standardFeeCount == feeCounts) {
        DIVIDED_PAYMENT_CUOTA.querySelector("#payment-divided-price-cuota-amount").innerHTML = priceFormat;
        if (!IS_SUBSCRIPTION) {
            DIVIDED_PAYMENT_CUOTA.querySelector("#payment-divided-price-cuota .months-amount").innerHTML = feeCounts;
        }
        QUOTA_PRICE_UPDATE.value = priceInfo.QuotaPrice;
    } else {
        const remainingAmount = totalAmount - initialFee;
        const feeAmount = remainingAmount / feeCounts;
        let roundedFeeAmount = Math.ceil(Math.round(feeAmount * 100) / 100);
        QUOTA_PRICE_UPDATE.value = roundedFeeAmount;
        if (priceFormat.indexOf(',') !== -1) {
            roundedFeeAmount = formatPrice(roundedFeeAmount, ',');
            standardQuotaPrice = formatPrice(standardQuotaPrice, ',');
        }
        if (priceFormat.indexOf('.') !== -1) {
            roundedFeeAmount = formatPrice(roundedFeeAmount, '.');
            standardQuotaPrice = formatPrice(standardQuotaPrice, '.');
        }
        DIVIDED_PAYMENT_CUOTA.querySelector("#payment-divided-price-cuota-amount").innerHTML = priceFormat.replace(standardQuotaPrice, roundedFeeAmount);
        DIVIDED_PAYMENT_CUOTA.querySelector("#payment-divided-price-cuota .months-amount").innerHTML = feeCounts;
        if (feeCounts == 1) {
            DIVIDED_PAYMENT_CUOTA.querySelector("#payment-divided-price-cuota").childNodes[1].textContent = " " + T.plazoSpan;
        } else {
            DIVIDED_PAYMENT_CUOTA.querySelector("#payment-divided-price-cuota").childNodes[1].textContent = " " + T.plazoSpanPlural;
        }

    }

}

function formatPrice(price, separator) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
}
export function selectExtension(countryCode, outForm = false) {
    const extensionInputFlag = document.getElementById('extension-input-flag');
    const extensionValue = document.getElementById('tech-phone-countries-button-value');
    extensionInputFlag.setAttribute('src', 'https://www.techtitute.com/techtitute/assets/flags/icons/' + countryCode + '.svg');
    extensionValue.setAttribute('user-country', countryCode);
    extensionValue.innerText = "+" + phoneUtil.getCountryCodeForRegion(countryCode);
    //examplePhoneNumber = phoneUtil.getExampleNumber(countryCode);
    if (phoneFormatter != null) {
        phoneFormatter = new AsYouTypeFormatter(countryCode);
    }
    changeCountryResidence(countryCode, "phone");
    if (!outForm) {
        toggleExtensionDropdown();
    }
}

export function formatPhoneNumber(element) {
    let phoneCountry = document.getElementById("tech-phone-countries-button-value").getAttribute("user-country");
    let number = phoneUtil.parseAndKeepRawInput(element.value, phoneCountry);
    validPhone = !!phoneUtil.isValidNumberForRegion(number, phoneCountry);
}

export function getIsValidPhone() {
    return validPhone;
}

export function selectCountry(countryCode) {
    const nationalityInputFlag = document.getElementById('nationality-input-flag');
    const nationalityInput = document.getElementById('tech-nationality-countries-button-value');
    nationalityInputFlag.setAttribute('src', 'https://www.techtitute.com/techtitute/assets/flags/icons/' + countryCode.toLowerCase() + '.svg')
    nationalityInput.innerText = countryCode;
    changeCountryResidence(countryCode, "country");
    toggleNationalityDropdown();
}

export function triggerDropdown(e, dropdown) {
    if (dropdown.classList.contains('tech-country-phones-extensions-dropdown')) {
        if (e.target !== document.getElementById("phone-extension-input-dropdown") && !document.getElementById("phone-extension-input-dropdown").contains(e.target)) {
            dropdown.classList.add('dropdown-hidden');
            document.removeEventListener("click", function (evt) {
                triggerDropdown(evt);
            })
        }
    }
    if (dropdown.classList.contains('tech-country-nationality-extensions-dropdown')) {
        if (e.target !== document.getElementById("nationality-input-dropdown") && !document.getElementById("nationality-input-dropdown").contains(e.target)) {
            dropdown.classList.add('dropdown-hidden');
            document.removeEventListener("click", function (evt) {
                triggerDropdown(evt)
            })
        }
    }
    if (dropdown.classList.contains('tech-country-input-dropdown')) {
        if (e.target !== document.getElementById("user-data-country-input-dropdown") && !document.getElementById("user-data-country-input-dropdown").contains(e.target)) {
            dropdown.classList.add('dropdown-hidden');
            document.removeEventListener("click", function (evt) {
                triggerDropdown(evt)
            })
        }
    }
    if (dropdown.classList.contains('user-data-country')) {
        if (e.target !== document.getElementById("user-data-country-dropdown") && !document.getElementById("user-data-country-dropdown").contains(e.target)) {
            dropdown.classList.add('dropdown-hidden');
            document.removeEventListener("click", function (evt) {
                triggerDropdown(evt)
            })
        }
    }
    if (dropdown.classList.contains('user-data-state')) {
        if (e.target !== document.getElementById("user-data-state-dropdown") && !document.getElementById("user-data-state-dropdown").contains(e.target)) {
            dropdown.classList.add('dropdown-hidden');
            document.removeEventListener("click", function (evt) {
                triggerDropdown(evt)
            })
        }
    }
}

export function toggleExtensionDropdown() {
    let dropdown = document.getElementById("extension-dropdown")
    if (dropdown.classList.contains('dropdown-hidden')) {
        dropdown.classList.remove('dropdown-hidden')
        document.addEventListener("click", function (evt) {
            triggerDropdown(evt, dropdown);
        })
    } else {
        dropdown.classList.add('dropdown-hidden');
        document.removeEventListener("click", function (evt) {
            triggerDropdown(evt);
        })
    }
    if (phoneExtensionsLoaded === false) {
        loadExtensionsStrings();
    }
}

export function toggleNationalityDropdown(countries) {
    let dropdown = document.getElementById("nationality-dropdown")
    if (dropdown.classList.contains('dropdown-hidden')) {
        dropdown.classList.remove('dropdown-hidden')
        document.addEventListener("click", function (evt) {
            triggerDropdown(evt, dropdown);
        })
    } else {
        dropdown.classList.add('dropdown-hidden');
        document.removeEventListener("click", function (evt) {
            triggerDropdown(evt);
        })
    }
    if (phoneExtensionsLoaded === false) {
        loadExtensionsStrings();
    }
}

export function toggleCountryDropdown(countries) {
    let dropdown = document.getElementById("user-data-country")
    if (dropdown.classList.contains('dropdown-hidden')) {
        dropdown.classList.remove('dropdown-hidden')
        document.addEventListener("click", function (evt) {
            triggerDropdown(evt, dropdown);
        })
    } else {
        dropdown.classList.add('dropdown-hidden');
        document.removeEventListener("click", function (evt) {
            triggerDropdown(evt);
        })
    }
    if (phoneExtensionsLoaded === false) {
        loadExtensionsStrings();
    }
}

export function loadExtensionsStrings() {
    document.querySelectorAll(".enrollment-dropdown-extension").forEach((c) => {
        c.innerHTML = "+" + phoneUtil.getCountryCodeForRegion(c.getAttribute('flag-country'));
        phoneExtensionsStrings.push({ "countryCode": c.getAttribute('flag-country'), "value": phoneUtil.getCountryCodeForRegion(c.getAttribute('flag-country')) + c.getAttribute('country-name') });
        var value = c.innerHTML; if (value.includes("+0")) { c.parentElement.style.display = "none"; }
    })
    //extensionsElements = document.getElementById("extensions-result");
    phoneExtensionsLoaded = true;
}

export function setDefaultPhoneExtension() {
    let phoneSpan = document.getElementById("tech-phone-countries-button-value")
    let extension = phoneUtil.getCountryCodeForRegion(phoneSpan.getAttribute("user-country"))
    phoneSpan.innerHTML = "+" + extension;
}

export function filterExtensions(searchExtensionInput) {
    let searchString = searchExtensionInput.value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    phoneExtensionsStrings.forEach((e) => {
        if (e.value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(searchString.toLowerCase())) {
            document.getElementById("extension-" + e.countryCode).classList.remove('extension-hidden');
        } else {
            let el = document.getElementById("extension-" + e.countryCode)
            if (!el.classList.contains('extension-hidden')) {
                el.classList.add('extension-hidden')
            }
        }
    })
}

export function filterCountries(searchCountryInput, resultContainer) {
    let searchString = searchCountryInput.value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    let countriesArray = document.querySelectorAll(resultContainer + ' .extension-flag');
    countriesArray.forEach((e) => {
        let itemString = e.children[1].getAttribute('country-name').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        if (itemString.includes(searchString.toLowerCase())) {
            e.classList.remove('extension-hidden');
        } else {
            if (!e.classList.contains('extension-hidden')) {
                e.classList.add('extension-hidden')
            }
        }
    })
}

/*export function toggleDropdown(dropdownElement, searchInput) {
    let dropdown = document.getElementById(dropdownElement);
    console.log(dropdown, dropdownElement);
    if (dropdown.classList.contains('dropdown-hidden')) {
        dropdown.classList.remove('dropdown-hidden')
        document.getElementById(searchInput).focus();
        document.addEventListener("click", function(evt) {
            triggerDropdown(evt, dropdown);
        })
    } else {
        dropdown.classList.add('dropdown-hidden');
        document.removeEventListener("click", function(evt) {
            triggerDropdown(evt);
        })
    }
    if (phoneExtensionsLoaded === false) {
        loadExtensionsStrings();
    }
}

export function filterSearch(searchInput, resultContainer, filterAttribute) {
    let searchString = document.getElementById(searchInput).value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    let contentToFilter = document.getElementById(resultContainer).children;
    Array.from(contentToFilter).forEach((e) => {
        let itemString = e.getAttribute(filterAttribute).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        if (!itemString.includes(searchString)) {
            e.classList.add('hidden-element');
        } else {
            if (e.classList.contains('hidden-element')) {
                e.classList.remove('hidden-element');
            }
        }
    })
}*/

export function buildUserDataBody() {

    userDataBody = {
        Gender: document.getElementById("user-data-gender-input"),
        Nationality: document.getElementById("user-data-nationality-input"),
        BirthDate: document.getElementById("user-data-birthdate-input"),
        Job: document.getElementById("user-data-profession-input"),
        Adress: document.getElementById("user-data-address-input"),
        Country: document.getElementById("user-data-country-input"),
        State: document.getElementById("user-data-state-input"),
        Location: document.getElementById("user-data-location-input") == null ? null : document.getElementById("user-data-location-input"),
        Subdivision: document.getElementById("user-data-subdivision-input") == null ? null : document.getElementById("user-data-subdivision-input"),
        Town: document.getElementById("user-data-town-input"),
        CP: document.getElementById("user-data-cp-input"),
    }

}

//NUEVO FORMULARIO DE MATRICULA

// FUNCION QUE VALIDA LOS CAMPOS DEL PRIMER PASO, SI NO LOS CUMPLE, NO NAVEGA
/*
* Recibe los elementos que contienen el input y el label para poder aplicar los estilos de error
* Con el querySelector pillamos el valor del input
* Para el email es necesaria una validación con expresión regular
* Para el teléfono se puede utilizar la librería instalada googlephonelib, provee métodos de validación
* Para el ID se requiere otra librería de validación, hay que investigar la mejor opción

* Utilizo operadores ternarios para facilitar la lectura, en caso de los campos que requieren más validaciones
  habrá que utilizar un bloque if :D

* Se puede implementar un sistema de errores personalizados, los elementos que recibe la función tienen un <span>
  para mostrar ese error. element.querySelector('span.tech-error-message').innerText = "{{mensaje_error}}"

* El ret permite navegar o no
*/

function SetPreenrollmentBlurEvent(wrapper) {
    wrapper.addEventListener("blur", function () {
        if (!leadSent) {
            if (tech.formFunctions.validateInput('text', 'enrollment-name', 100, true, false) && tech.formFunctions.validateInput('text', 'enrollment-last-name', 100, true, false) && tech.formFunctions.validateInput('email', 'enrollment-email', 320, true, false) && tech.formFunctions.validateInput('phone', 'enrollment-phone', 20, true, false)) {
                preEnrollmentNotification();
                leadSent = true;
            }
        }
    });
}

function validInputForPreEnroll(firstName, lastName, email, extension, phone) {
    let ret = true;
    const firstNameValue = firstName.querySelector('input').value;
    const lastNameValue = lastName.querySelector('input').value;
    const emailValue = email.querySelector('input').value;
    const phoneValue = phone.querySelector('input').value;

    if (firstNameValue.length === 0) {
        ret = false;
    } else if (tech.formFunctions.validTextField(firstNameValue) === false) {
        ret = false;
    }
    if (lastNameValue.length === 0) {
        ret = false;
    } else if (tech.formFunctions.validTextField(lastNameValue) === false) {
        ret = false;
    }
    if (emailValue.length === 0) {
        ret = false;
    } else if (validEmail(emailValue) === false) {
        ret = false;
    }
    if (phoneValue.length === 0) {
        ret = false;
    } else if (validPhone === false) {
        ret = false;
    }

    return ret;
}

var revalidationActive = false;
function setReValidateInputEvent(input, inputType) {
    if (inputType !== "checkbox") {
        input.querySelector('input').addEventListener("blur", (event) => validateOnBlur(input))
    }
}

function validateOnBlur(input) {
    validateFirstStep(NAME_INPUT, LAST_NAME_INPUT, SECOND_LAST_NAME_INPUT, EMAIL_INPUT, PHONE_EXT_INPUT, PHONE_INPUT, ID_INPUT, GENERAL_CONDITIONS_INPUT) ? document.getElementById('tech-general-error').innerText = "" : document.getElementById('tech-general-error').innerText = T.invalidForm;
}
function validateFirstStep(firstName, lastName, secondLastName, email, extension, phone, id, generalConditions) {
    let ret = true;
    const firstNameValue = firstName.querySelector('input').value;
    const lastNameValue = lastName.querySelector('input').value;
    const secondLastNameValue = secondLastName.querySelector('input').value;
    const emailValue = email.querySelector('input').value;
    const phoneValue = phone.querySelector('input').value;
    const idValue = id.querySelector('input').value;
    const generalConditionsValue = generalConditions.querySelector('input').checked;


    if (firstNameValue.trim().length === 0) {
        setReValidateInputEvent(firstName, "text");
        firstName.querySelector('span.tech-error-message').innerText = T.campoObligatorio;
        ret = false;
    } else if (firstNameValue.trim().length > 100) {
        firstName.querySelector('span.tech-error-message').innerText = "Max length 100";
        setReValidateInputEvent(firstName, "welcomeForm");
        ret = false;
    } else if (tech.formFunctions.validTextField(firstNameValue) === false) {
        setReValidateInputEvent(firstName, "text");
        firstName.querySelector('span.tech-error-message').innerText = T.textError;
        ret = false;
    } else {
        firstName.querySelector('span.tech-error-message').innerText = "";
    }

    if (lastNameValue.trim().length === 0) {
        setReValidateInputEvent(lastName, "text");
        lastName.querySelector('span.tech-error-message').innerText = T.campoObligatorio;
        ret = false;
    } else if (lastNameValue.trim().length > 100) {
        lastName.querySelector('span.tech-error-message').innerText = "Max length 100";
        setReValidateInputEvent(lastName, "welcomeForm");
        ret = false;
    } else if (tech.formFunctions.validTextField(lastNameValue) === false) {
        setReValidateInputEvent(lastName, "text");
        lastName.querySelector('span.tech-error-message').innerText = T.textError;
        ret = false;
    } else {
        lastName.querySelector('span.tech-error-message').innerText = "";
    }

    if (tech.formFunctions.validTextField(secondLastNameValue) === false) {
        setReValidateInputEvent(secondLastName, "text");
        secondLastName.querySelector('span.tech-error-message').innerText = T.textError;
        ret = false;
    } else if (secondLastNameValue.trim().length > 100) {
        secondLastName.querySelector('span.tech-error-message').innerText = "Max length 100";
        setReValidateInputEvent(secondLastName, "welcomeForm");
        ret = false;
    } else {
        secondLastName.querySelector('span.tech-error-message').innerText = "";
    }

    if (emailValue.trim().length === 0) {
        setReValidateInputEvent(email, "email");
        email.querySelector('span.tech-error-message').innerText = T.campoObligatorio;
        ret = false;
    } else if (emailValue.trim().length > 200) {
        email.querySelector('span.tech-error-message').innerText = "Max length 100";
        setReValidateInputEvent(email, "welcomeForm");
        ret = false;
    } else if (validEmail(emailValue) === false) {
        setReValidateInputEvent(email, "email");
        email.querySelector('span.tech-error-message').innerText = T.emailError;
        ret = false;
    } else {
        email.querySelector('span.tech-error-message').innerText = "";
    }

    if (phoneValue.trim().length === 0) {
        setReValidateInputEvent(phone, "phone");
        phone.querySelector('span.tech-error-message').innerText = T.campoObligatorio;
        ret = false;
    } else if (phoneValue.trim().length > 20) {
        phone.querySelector('span.tech-error-message').innerText = "Max length 20";
        setReValidateInputEvent(phone, "welcomeForm");
        ret = false;
    } else if (validPhone === false) {
        setReValidateInputEvent(phone, "phone");
        phone.querySelector('span.tech-error-message').innerText = T.tlfError;
        ret = false;
    } else {
        phone.querySelector('span.tech-error-message').innerText = "";
    }
    if (idValue.trim().length === 0) {
        setReValidateInputEvent(id, "text");
        id.querySelector('span.tech-error-message').innerText = T.idError;
        ret = false;
    } else if (idValue.trim().length > 20) {
        id.querySelector('span.tech-error-message').innerText = "Max length 20";
        setReValidateInputEvent(id, "welcomeForm");
        ret = false;
    } else {
        id.querySelector('span.tech-error-message').innerText = "";
    }
    if (generalConditionsValue === false) {
        setReValidateInputEvent(generalConditions, "checkbox");
        generalConditions.querySelector('span.tech-error-message').innerText = T.lopdErrir;
        ret = false;
    } else {
        generalConditions.querySelector('span.tech-error-message').innerText = "";
    }

    return ret;
}

//FUNCIONES DE VALIDACION DISTINTOS TIPOS DE INPUTS

export function formatPhoneOnType(key) {
    let inputValue = document.getElementById("enrollment-phone-input").value;

}
export function validEmail(email) {
    email = email.toLowerCase();
    const regex = /^[a-z0-9]+([._a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$/;
    return regex.test(email);
}
//_____FIN FUNCIONES DE VALIDACION


//FUNCION PARA NAVEGAR DENTRO DEL FORMULARIO CON EL BOTON ATRAS O CUANDO SE HACE CLICK EN SUBMIT
export function navigateEnrollmentSteps(step) {
    document.getElementById('tech-general-error').innerText = "";
    var PROMO_CODE_CONTAINER = null;
    if (!CRMOrder) PROMO_CODE_CONTAINER = document.getElementById('promo-code-container');

    const PERSONAL_DATA_PRICE = document.getElementById('personal-data-step-price');
    const PAYMENT_DATA_PRICE = document.getElementById('payment-data-step-price')
    if (step === "firstStep") {
        let errors = [];
        errors.push(tech.formFunctions.validateInput('text', 'enrollment-name', 100, true));
        errors.push(tech.formFunctions.validateInput('text', 'enrollment-last-name', 100, true));
        errors.push(tech.formFunctions.validateInput('text', 'enrollment-second-last-name', 100, false));
        errors.push(tech.formFunctions.validateInput('email', 'enrollment-email', 320, true));
        errors.push(tech.formFunctions.validateInput('phone', 'enrollment-phone', 20, true));
        errors.push(tech.formFunctions.validateInput('text', 'enrollment-id', 15, true));
        errors.push(tech.formFunctions.validateInput('checkbox', 'enrollment-generalConditions', 1, true));
        // VALIDATORS
        if (!errors.includes(false)) {
            var itemCaller = document.getElementById("first-step-form-inputs");
            tech.captchaV3.reCaptcha(itemCaller, tech.newEnrollment.showSecondStep, "enrollment");
            document.getElementById('user-email').value = document.getElementById('enrollment-email-input').value;
        } else {
            document.getElementById('tech-general-error').innerText = T.invalidForm
        }
    } else if (step === "secondStep") {
        if (PROMO_CODE_CONTAINER != null) PROMO_CODE_CONTAINER.classList.remove("hidden-element");
        FIRST_STEP.classList.remove("tech-enrollment-step-hidden");
        SECOND_STEP.classList.add("tech-enrollment-step-hidden");
        tech.formFunctions.scrollToElement(FIRST_STEP);
        PERSONAL_DATA_PRICE.classList.remove("hidden-element");
        PAYMENT_DATA_PRICE.classList.add("hidden-element");
    } else if (step === "thirdStep") {
        THIRD_STEP.classList.add("tech-enrollment-step-hidden");
        tech.formFunctions.scrollToElement(SECOND_STEP);
        SECOND_STEP.classList.remove("tech-enrollment-step-hidden");
        //Se limpia el contenedor
        PAYMETHOD_CONTAINER.innerHTML = "";
        //Se busca si hay algun spinner activo y el paso disabled para activarlo
        isStepDisabled(SECOND_STEP)
    }
}

export function showSecondStep() {
    if (!CRMOrder) {
        var PROMO_CODE_CONTAINER = document.getElementById('promo-code-container');
        PROMO_CODE_CONTAINER?.classList.add("hidden-element");
    }
    var PERSONAL_DATA_PRICE = document.getElementById('personal-data-step-price');
    var PAYMENT_DATA_PRICE = document.getElementById('payment-data-step-price');

    payModeSelected = document.getElementById("tech-plazos-button-radio").checked ? "plazos" : "contado";

    PERSONAL_DATA_PRICE.classList.add("hidden-element");
    PAYMENT_DATA_PRICE.classList.remove("hidden-element");
    SECOND_STEP.classList.remove("tech-enrollment-step-hidden");
    FIRST_STEP.classList.add("tech-enrollment-step-hidden");
    //SET CONTADO DEFAULT
    selectPayForm(payModeSelected);
}


function reCaptcha(itemCaller, callback) {
    let ret = false;

    grecaptcha.enterprise.ready(function () {
        grecaptcha.enterprise.execute("6LcqQ84pAAAAAO06i0G7bRuKB1F916eKmufUTlmu", {action: "enrollment"}).then(function(token) {
            $.ajax({
                type: 'POST',
                url: '/Recaptcha/VerifyTokenV3',
                dataType: 'JSON',
                data: {
                    token: token
                },
                success: successFunc,
                error: errorFunc
            });
            function successFunc(response) {
                var param = tech.core.getParameterByName('forceRecaptcha');
                if (param == null) {
                    if (response.riskAnalysis.score <= 0.5) {
                        IsBoot = false;
                        if (typeof callback !== "undefined") {
                            itemCaller.disabled = false;
                            callback();
                        }
                    } else {
                        showCaptchaVII.call(itemCaller);
                    }
                } else {
                    showCaptchaVII.call(itemCaller);
                }
            }

            function errorFunc(jQXHR, textStatus, errorThrown) {
                //deleteVII();
                console.log("An error occurred while trying to contact the server: " + jQXHR.status + " " + textStatus + " " + errorThrown);
                return false;
            }

            function showCaptchaVII() {
                if (IsBoot) {
                    if (document.getElementById("recDiv") === undefined || document.getElementById("recDiv") == null) {
                        var script = document.createElement("script");
                        script.src = "https://www.google.com/recaptcha/api.js" + '?hl=' + tech.core.getCookie(tech.core.COOKIE_LANGUAGE_CODE);
                        script.onload = script.onreadystatechange = function () {
                            var recpDiv;
                            var objTo = itemCaller;
                            var captchaContainer = document.getElementById("recDiv");
                            if (captchaContainer != null) {
                                captchaContainer.innerHTML = "";
                            } else {
                                recpDiv = document.createElement("div");
                            }
                            recpDiv.setAttribute("id", "recDiv");
                            recpDiv.setAttribute("style", "margin: 0 auto;");
                            objTo.appendChild(recpDiv);
                            grecaptcha.enterprise.render(document.getElementById("recDiv"), {
                                'sitekey': '6LcM09YpAAAAALkFFSQMCD2ReZDytsoNvmVFIwgS',
                                'callback': callback,
                                'theme': 'light'
                            });
                        }
                        var body = document.getElementsByTagName("body")[0];
                        (body || document.body).appendChild(script);
                    }
                } else {
                    itemCaller.disabled = false;
                    callback();
                }
            }
        })
    })
}

function deleteVII() {
    var recDiv = document.getElementById("recDiv");
    var parentNode = recDiv.parentNode;
    var deletedItem = parentNode.removeChild(recDiv);

}

function togglePaymentMethod() {
    let tarjetaButton = document.getElementById("tarjetaButton");
    let cuentaButton = document.getElementById("cuentaButton");
    let tarjetaSpinner = document.getElementById("spinner-tarjeta-button");
    let cuentaSpinner = document.getElementById("spinner-cuenta-button");
    tarjetaButton.classList.toggle('disabled');
    tarjetaSpinner.classList.toggle('hidden-element');
    cuentaButton.classList.toggle('disabled');
    cuentaSpinner.classList.toggle('hidden-element');
}

//FUNCION PARA CREAR EL PREORDER 
function createPreOrder() {
    preOrderReq = null;
    togglePaymentMethod();
    var body = buildRequestBody();
    // Testing purposes - Switch true with this line: body.PaymentInfo.PaymentType.includes('redsys') OR body.PaymentInfo.PaymentType.includes('stripe')
    //if (body.PaymentInfo.PaymentType.includes('redsys')) {
    if (body.PaymentInfo.PaymentType.includes('redsys') || body.PaymentInfo.PaymentType.includes('stripe') || body.PaymentInfo.PaymentType.includes('ebanx') || body.PaymentInfo.PaymentType.includes('payway')) {
        return new Promise((resolve, reject) => {
            preOrderReq = $.ajax({
                type: 'POST',
                url: tech.core.getInternationalUrl('/Course/CreatePreOrderNew'),
                data: JSON.stringify(body),
                contentType: 'application/json',
                dataType: 'json',
                success: function (response) {
                    if (response.succed === true) {
                        PREORDER_DATA.value = JSON.stringify(response.data);
                        numPedido = response.data.order.numPedido.toString();


                        //hotjarEvent(numPedido);
                        togglePaymentMethod();
                        resolve();
                    } else {
                        PREORDER_DATA.value = "ERROR-PREORDER";
                        togglePaymentMethod();
                        reject();
                    }

                },
                error: function (jQXHR, textStatus, errorThrown) {
                    console.log("An error occurred while trying to contact the server: " + jQXHR.status + " " + textStatus + " " + errorThrown);
                    PREORDER_DATA.value = "ERROR-PREORDER";
                    togglePaymentMethod();
                    reject();
                },
            })
        });
    } else {
        togglePaymentMethod();
        return new Promise((resolve) => {
            resolve();
        });
    }

}

function releaseSecondStep() {
    const CONTADO_BUTTON = document.getElementById("contadoButton");
    const PLAZOS_BUTTON = document.getElementById("plazosButton");
    const CUENTA_BUTTON = document.getElementById("cuentaButton");
    const TARJETA_BUTTON = document.getElementById("tarjetaButton");
    const INPUT_PLAZOS = document.getElementById("input-plazos");

    CONTADO_BUTTON != null ? CONTADO_BUTTON.classList.remove('disabled') : "";
    PLAZOS_BUTTON != null ? PLAZOS_BUTTON.classList.remove('disabled') : "";
    CUENTA_BUTTON != null ? CUENTA_BUTTON.classList.remove('disabled') : "";
    TARJETA_BUTTON != null ? TARJETA_BUTTON.classList.remove('disabled') : "";
    INPUT_PLAZOS != null ? INPUT_PLAZOS.classList.remove('disabled') : "";
}

function hotjarEvent(numPedido) {
    hj('event', "Numero pedido: " + numPedido);
}

function checkAjaxPreorderStatus(xhr) {

    return new Promise(function (resolve) {
        if (xhr.readyState !== 4) {
            // La llamada AJAX sigue en ejecucion, añadimos un spinner
            tech.formFunctions.toggleSpinner('spinner-tarjeta-button', ['tarjetaButtonText'], ['enrollment-second-step']);
            //Añadimos un evento a la espera de que se resuleva la llamada
            xhr.always(function () {
                tech.formFunctions.toggleSpinner('spinner-tarjeta-button', ['tarjetaButtonText'], ['enrollment-second-step']);
                resolve();
            });
        } else {
            resolve();
        }
    });
}

function checkAjaxPreorderStatusRedsys(xhr) {
    return new Promise(function (resolve) {
        if (xhr.readyState !== 4) {
            // La llamada AJAX sigue en ejecucion, añadimos un spinner
            tech.formFunctions.toggleSpinnerBlock('enrollment-spinner', 'enrollment-third-step', '', '', true);
            //Añadimos un evento a la espera de que se resuleva la llamada
            xhr.always(function () {
                tech.formFunctions.toggleSpinnerBlock('enrollment-spinner', 'enrollment-third-step', '', '', false);
                resolve();
            });
        } else {
            resolve();
        }
    });
}


//FUNCION QUE INSERTA EL LA VISTA PARCIAL DEL METODO SELECCIONADO

export function selectPayMethod(methodPay) {
    payMethodSelected = methodPay;

    if (methodPay === 'tarjeta') {
        if (isRedsysPayment) {
            checkAjaxPreorderStatus(preOrderReq).then(function () {
                changePaymentMethod(methodPay);
            });
        } else if (isStripePayment) {
            checkAjaxPreorderStatus(preOrderReq).then(function () {
                changePaymentMethod(methodPay);
            });
        } else if (isEbanxsPayment) {
            checkAjaxPreorderStatus(preOrderReq).then(function () {
                changePaymentMethod(methodPay);
            });
        } else if (isPaywayPayment) {
            checkAjaxPreorderStatus(preOrderReq).then(function () {
                changePaymentMethod(methodPay);
            });
        } else {
            changePaymentMethod(methodPay);
        }
    } else if (methodPay === 'cuenta') {
        changePaymentMethod(methodPay)
    } else {
        changePaymentMethod(methodPay);
    }
}

function changePaymentMethod(methodPay) {
    if ((PREORDER_DATA.value === 'ERROR-PREORDER' || PREORDER_DATA.value === '') && methodPay === 'tarjeta') {

        tech.formFunctions.toggleSpinner('spinner-tarjeta-button', ['tarjetaButtonText'], ['enrollment-second-step']);
        createPreOrder().then(function () {

            //tech.formFunctions.toggleSpinner('spinner-tarjeta-button', ['tarjetaButtonText'], ['enrollment-second-step']);
            selectPayMethodAjax(methodPay);
        }).catch(function () {
            tech.formFunctions.toggleSpinner('spinner-tarjeta-button', ['tarjetaButtonText'], ['enrollment-second-step']);
            showPaymentInfoModal(T.errorMatricula);
        });
    } else {

        createPreOrder().then(function () {
            selectPayMethodAjax(methodPay);
        }).catch(err => {
        });
        //tech.formFunctions.toggleSpinner('spinner-tarjeta-button', ['tarjetaButtonText'], ['enrollment-second-step']);
        //tech.formFunctions.toggleSpinner('spinner-tarjeta-button', ['cuentaButton'], ['enrollment-second-step']);

    }
}

function selectPayMethodAjax(methodPay, refresh) {
    var body = {
        CardInfo: (PREORDER_DATA.value === 'ERROR-PREORDER' || PREORDER_DATA.value === '') ? null : JSON.parse(PREORDER_DATA.value),
        Method: methodPay,
        Mode: paymentModeSelected,
        PaymentModes: paymentModes
    };
    $.ajax({
        type: 'POST',
        url: tech.core.getInternationalUrl('/Course/SelectPayMethod'),
        data: JSON.stringify(body),
        contentType: 'application/json',
        dataType: 'html',
        success: successFunc,
        error: errorFunc,
    });

    function successFunc(response, status) {

        if (refresh == true) {
            PAYMETHOD_CONTAINER.innerHTML = "";
        }
        $('#enrollment-third-step').append(response);

        if (typeof callback !== "undefined") {
            callback();
        }
        tech.formFunctions.toggleSpinner('spinner-tarjeta-button', ['tarjetaButtonText'], ['enrollment-second-step']);
        SECOND_STEP.classList.add('tech-enrollment-step-hidden');
        THIRD_STEP.classList.remove('tech-enrollment-step-hidden');
    }

    function errorFunc(jQXHR, textStatus, errorThrown) {
        console.log("An error occurred while trying to contact the server: " + jQXHR.status + " " + textStatus + " " + errorThrown);
        tech.formFunctions.toggleSpinner('spinner-tarjeta-button', ['tarjetaButtonText'], ['enrollment-second-step']);
    }

}

export function refreshRedsysOnError() {

    let methodPay = 'tarjeta';
    createPreOrder().catch(err => {
    });

    checkAjaxPreorderStatusRedsys(preOrderReq).then(function () {
        if ((PREORDER_DATA.value === 'ERROR-PREORDER' || PREORDER_DATA.value === '') && methodPay === 'tarjeta') {
            tech.formFunctions.toggleSpinnerBlock('enrollment-spinner', 'enrollment-third-step', '', '', true);
            createPreOrder().then(function () {
                tech.formFunctions.toggleSpinnerBlock('enrollment-spinner', 'enrollment-third-step', '', '', false);
                selectPayMethodAjax(methodPay, true);
            }).catch(function () {
                tech.formFunctions.toggleSpinnerBlock('enrollment-spinner', 'enrollment-third-step', '', '', false);
                showPaymentInfoModal(T.errorMatricula);
            });
        } else {
            selectPayMethodAjax(methodPay, true);
        }
    });
}

function isStepDisabled(step) {

    var cardButton = step.querySelector('#tarjetaButton');
    var accountButton = step.querySelector('#cuentaButton');
    var tarjetaButtonText = cardButton.querySelector('#tarjetaButtonText');
    var cuentaButtonText = accountButton.querySelector('#cuentaButtonText');

    var isHiddenButton = null;
    var isDisabledButton = null;
    var isTextHidden = null;

    // SE COMPRUEBA QUE EL BOTÓN ESTÉ MOSTRADO
    if (cardButton != null && cardButton.classList.contains('hidden-element')) {
        isHiddenButton = 'tarjetaButton';
    } else if (accountButton != null && accountButton.classList.contains('hidden-element')) {
        isHiddenButton = 'cuentaButton';
    }

    // SE COMPRUEBA AQUELLOS BOTONES NO OCULTOS PARA VER SI ESTÁN DESHABILITADOS
    if (cardButton != null && isHiddenButton != 'tarjetaButton' && cardButton.classList.contains('disabled')) {
        isDisabledButton = 'tarjetaButton';
    } else if (accountButton != null && isHiddenButton != 'cuentaButton' && accountButton.classList.contains('disabled')) {
        isDisabledButton = 'cuentaButton';
    }

    // SE COMPRUEBA AQUELLOS TEXTOS QUE ESTÉN OCULTOS Y QUE CUYO BOTÓN NO ESTÉ ESCONDIDO 
    if (tarjetaButtonText != null && isHiddenButton !== "tarjetaButton" && tarjetaButtonText.classList.contains('hidden-element')) {
        isTextHidden = ['tarjetaButtonText'];
    } else if (cuentaButtonText != null && isHiddenButton !== "cuentaButton" && cuentaButtonText.classList.contains('hidden-element')) {
        isTextHidden = ['cuentaButtonText'];
    }

    // SE COMPRUEBA SI EL STEP DE REGRESO ESTÁ DESHABILITADO
    if (step.classList.contains('disabled')) {
        if (isDisabledButton != null) {
            if (isDisabledButton === 'tarjetaButton') {
                tech.formFunctions.toggleSpinner('spinner-tarjeta-button', isTextHidden, ['enrollment-second-step']);
            } else if (isDisabledButton === 'cuentaButton') {
                tech.formFunctions.toggleSpinner('spinner-cuenta-button', isTextHidden, ['enrollment-second-step']);
            }
        } else {
            if (isTextHidden.includes('tarjetaButtonText')) {
                tech.formFunctions.toggleSpinner('spinner-tarjeta-button', isTextHidden, ['enrollment-second-step']);
            } else if (isTextHidden.includes('cuentaButtonText')) {
                tech.formFunctions.toggleSpinner('spinner-cuenta-button', isTextHidden, ['enrollment-second-step']);
            }
        }

    } else {
        if (isDisabledButton != null) {
            if (isDisabledButton === 'tarjetaButton') {
                tech.formFunctions.toggleSpinner('spinner-tarjeta-button', isTextHidden, null);
            } else if (isDisabledButton === 'cuentaButton') {
                tech.formFunctions.toggleSpinner('spinner-cuenta-button', isTextHidden, null);
            }
        } else {
            if (isTextHidden.includes('tarjetaButtonText')) {
                tech.formFunctions.toggleSpinner('spinner-tarjeta-button', isTextHidden, null);
            } else if (isTextHidden.includes('cuentaButtonText')) {
                tech.formFunctions.toggleSpinner('spinner-cuenta-button', isTextHidden, null);
            }
        }
    }
}
function EnrollmentId() {
    let enrollmentId = document.getElementById('enrollment-id-label')
    if (enrollmentId.innerText.length <= 9) {
        enrollmentId.style.paddingInlineEnd = "4px";
    } else {
        enrollmentId.style.paddingInlineEnd = '';
    }
}
EnrollmentId();

export function TogglePaymentMode(modeSelected) {
    paymentModeSelected = modeSelected == UPFRONT_PAYMENT ? UPFRONT_PAYMENT : SPLIT_PAYMENT;
}
